import React from 'react';

import get from 'ts-get';

import { useRutilusQuery } from '../../../../../../api/graphql/useRutilusQuery';
import { useAnalytics } from '../../../../../../contexts/AnalyticsContext/AnalyticsContext';
import { trackEvent } from '../../../../../../helpers/analytics/trackEvent';
import {
  GetManageablePageStatuses,
  GetManageablePageStatuses_entry_manageablePages_edges as PageEdge,
  GetManageablePageStatuses_entry_manageablePages_edges_node,
} from '../../../../../../interfaces/graphql';
import { getManageablePageStatuses } from '../../../../../../queries/rutilus/Me';
import { Heading } from '../../../../../Heading/Heading';
import { StatsIcon } from '../../../../../Icons/StatsIcon';
import { StatusIndicator } from '../../../../../StatusIndicator/StatusIndicator';

import { BrandLabel } from './BrandLabel';
import { SettingsIcon } from '../../../../../Icons/SettingsIcon';
import { CreatePostButton } from './CreatePostButton';
import { InternalLink } from '../../../../../Clickables/InternalLink/InternalLink';
import { getPageAdminUrl, getPageAnalyticsUrl } from '../../../../../../helpers/urls';

export interface IPageMenuItemsProps {
  navigateTo: (path: string) => void;
  onExpandedChange: (value: boolean) => void;
}

export const BrandMenu = ({ navigateTo, onExpandedChange }: IPageMenuItemsProps) => {
  const { data, error, loading } =
    useRutilusQuery<GetManageablePageStatuses>(getManageablePageStatuses);
  const { currentPage } = useAnalytics();

  if (error || loading || !data) {
    return <></>;
  }

  const pages = get<GetManageablePageStatuses, PageEdge[]>(
    data,
    it => it.entry.manageablePages.edges,
    [],
  )
    .map(i => i.node)
    .filter((page): page is GetManageablePageStatuses_entry_manageablePages_edges_node => !!page);

  return pages.length > 0 ? (
    <Heading variant="xs" as="div" className="text-abyss m-0 mb-4 md:text-base!">
      Brands
      <div className="mt-4">
        {pages.map(page => {
          return (
            <div key={page.legacyId} className="flex items-center pb-4">
              <BrandLabel navigateTo={navigateTo} page={page}>
                <StatusIndicator
                  id={`page-status-${page.legacyId}`}
                  status={page.published}
                  tooltipDescription={page.published ? 'Published' : 'Not Published'}
                />
                {page.name}
              </BrandLabel>
              <InternalLink
                variant="textPrimary"
                className="text-pinktail-shade ml-2"
                to={getPageAdminUrl(page._id)}
                onClick={() => {
                  void trackEvent({
                    name: 'mykiss_hamburger_clicked',
                    properties: { action: 'navigate', source: currentPage },
                  });
                }}
              >
                <SettingsIcon size={24} />
              </InternalLink>
              <InternalLink
                variant="textPrimary"
                className="text-pinktail-shade ml-2"
                to={getPageAnalyticsUrl(page._id)}
                onClick={() => {
                  void trackEvent({
                    name: 'mykiss_hamburger_clicked',
                    properties: { action: 'navigate', source: currentPage },
                  });
                }}
              >
                <StatsIcon size={24} />
              </InternalLink>
            </div>
          );
        })}
      </div>
      <CreatePostButton
        className="px-9 text-base md:w-full"
        onClick={() => {
          onExpandedChange(false);
        }}
      />
    </Heading>
  ) : (
    <></>
  );
};
